.section {
    padding: 0;
}

.heading {
    margin: 0 0 20px;
}

.noResults {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.track {
    margin-top: 20px;
}
